import type { ReactNode } from "react";
import { cx } from "./cx";

export interface RadioOption<V extends string = string> { value: V; label: ReactNode; description?: ReactNode; disabled?: boolean }

export interface RadioGroupProps<V extends string> {
  name: string;
  value: V | null;
  onChange: (v: V) => void;
  options: RadioOption<V>[];
  /** 只在选项没有说明时横排。 */
  inline?: boolean;
  label?: string;
  disabled?: boolean;
}

/** 互斥且少于 6 个选项的配置用它，更多或需要搜索用 Combobox。 */
export function RadioGroup<V extends string>({ name, value, onChange, options, inline, label, disabled }: RadioGroupProps<V>) {
  return (
    <div className={cx("ax-radio-group", inline && "inline")} role="radiogroup" aria-label={label}>
      {options.map((o) => (
        <label key={o.value} className="ax-radio">
          <input type="radio" name={name} value={o.value} checked={value === o.value} disabled={o.disabled || disabled} onChange={() => onChange(o.value)} />
          <span className="ax-radio-dot" aria-hidden />
          <span className="ax-check-text">
            <span>{o.label}</span>
            {o.description && <span className="ax-check-desc">{o.description}</span>}
          </span>
        </label>
      ))}
    </div>
  );
}
